import { IApplicationState } from '../../../../types/redux';
import { TTypedThunkDispatch } from '../../../../types/thunk';
import { initJsonQuery } from '../../../../actions/filters';
import { setTags } from '../../../../actions/filterTags';
import { setLocationPage } from '../../../../actions/location';
import { getOffersData } from '../../../../actions/offersData';
import { setCurrentRegion } from '../../../../actions/region/currentRegion';
import { triggerHeaderRegionChanged } from '../../../../utils/events/triggerHeaderRegionChanged';

export function getRealSubdomain(): string {
  return window.location.host.split('.')[0];
}

export function isGeoPathAvailable(subdomain: string, realSubdomain: string): boolean {
  if (realSubdomain !== 'www') {
    return false;
  }

  return realSubdomain !== subdomain;
}

export function initPushState(
  state: IApplicationState,
  dispatch: TTypedThunkDispatch,
  realSubdomain: string = getRealSubdomain(),
): void {
  const {
    jsonQuery,
    region: { currentRegion },
    location: { path, page, subdomain },
    offersData: { seo },
    filters: { tags },
  } = state;
  const title = (seo && seo.title) || document.title || '';

  triggerHeaderRegionChanged(currentRegion);

  const geoPathAvailable = isGeoPathAvailable(subdomain, realSubdomain);
  const pathPrefix = geoPathAvailable ? `/${subdomain}` : '';
  const fullPath = `${pathPrefix}${path}`;

  if (geoPathAvailable) {
    dispatch(
      setLocationPage({
        geoPath: subdomain,
        path: fullPath,
      }),
    );
  }

  window.history.replaceState(
    {
      jsonQuery,
      currentRegion,
      path: fullPath,
      page,
      title,
      tags,
    },
    title,
    fullPath,
  );
}

export function createPopStateHandler(dispatch: TTypedThunkDispatch) {
  return ({ state }: PopStateEvent) => {
    if (state && state.jsonQuery && state.path && state.page) {
      document.title = state.title || document.title;
      dispatch(initJsonQuery(state.jsonQuery));
      dispatch(setCurrentRegion(state.currentRegion));
      dispatch(setTags(state.tags || []));
      dispatch(
        getOffersData({
          reason: 'popstate',
          shouldUpdateHistory: false,
          path: state.path,
          page: state.page,
        }),
      );
    }
  };
}
